import React from 'react';
import { ReactComponent as AdaptIcon } from 'Assets/svg/adapt-logo.svg';
import { ReactComponent as SwapIcon } from 'Assets/svg/swap.svg';
import { HocPopupComponent } from 'Components/common/hocPopupComponent';
import Button from 'Components/common/Button';
import './integrationPopup.scss';

const IntegrationPopup = props => {
  const { data, closePopup } = props;
  const Image = data?.imgComponent;

  return (
    <HocPopupComponent
      showCloseIcon
      customClassName="integrations-popup"
      closeClick={closePopup}
    >
      <div className="icon-wrap">
        <div className="icon-box">
          <AdaptIcon />
        </div>
        <SwapIcon className="swap-icon" />
        <div className="icon-box">
          {data.isSvg ? (
            <Image className="logo" />
          ) : (
            <img src={Image} alt={data.title} className="logo" />
          )}
        </div>
      </div>
      <div className="title">Export Contacts</div>
      <div className="message">
        {`To export contacts to your ${data.title} CRM, Please add contacts to a list, and
        then export it from the 'My Lists' page.`}
      </div>
      <Button btnText="Ok" click={closePopup} />
    </HocPopupComponent>
  );
};

export default IntegrationPopup;
